import { getEnvironmentConfig, getEnvVariableDefault } from '../configHelper.js';
const definition = {
    base: {
        apiUrl: getEnvVariableDefault('CA_API_URL', ''),
        apiKeyAdmin: getEnvVariableDefault('CA_API_KEY_ADMIN', ''),
        apiKeyGuest: getEnvVariableDefault('CA_API_KEY_GUEST', ''),
        aissist: {
            apiUrl: getEnvVariableDefault('CA_AISSIST_API_URL', 'https://aissist-backend.bv.burda.com'),
            apiToken: getEnvVariableDefault('CA_AISSIST_API_KEY', ''),
        },
    },
    local: {
        apiUrl: 'https://dev.content-v2.assembler.services',
        apiKeyAdmin: 'G5P^9E0Ax4i2',
        apiKeyGuest: '9tZE34yYj3#X',
        aissist: {
            apiUrl: 'https://stage-aissist-backend.bv.burda.com',
            apiToken: '<< CONTACT AISSIST TEAM TO GET YOUR TOKEN >>',
        },
    },
    local_k8s: {
        apiUrl: 'https://dev.content-v2.assembler.services',
        apiKeyAdmin: 'G5P^9E0Ax4i2',
        apiKeyGuest: '9tZE34yYj3#X',
        aissist: {
            apiUrl: 'https://stage-aissist-backend.bv.burda.com',
            apiToken: '<< CONTACT AISSIST TEAM TO GET YOUR TOKEN >>',
        },
    },
};
export const assemblerConfig = () => getEnvironmentConfig(definition);
//# sourceMappingURL=assembler.config.js.map